export enum UserRole {
  SUPERADMIN = "superadmin",
  ADMIN = "admin",
  CORPORATE_ADMIN = "corporate_admin",
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  active: boolean;
  invitePending: boolean;
  organisationId?: string;
  createdBy?: string;
  lastLogin?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateUserDto {
  name: string;
  email: string;
  password: string;
  role?: UserRole;
  active?: boolean;
  organisationId?: string;
}

export interface UpdateUserDto {
  name?: string;
  password?: string;
  role?: UserRole;
  active?: boolean;
  organisationId?: string;
}
